import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-linkedin";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>poojamahantesh25@gmail.com</span>
        <div className="f-icons">
            <a href="https://www.instagram.com/princess_pooja_02?igsh=Z3g2d2g0YWRlanV1">
          <Insta color="white" size={"3rem"} /></a>
          <a href="https://www.linkedin.com/in/pooja-badasad-1526722ba?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
          <Facebook color="white" size={"3rem"} /></a>
          <a href="https://github.com/badasadpooja123/my-projects">
          <Gitub color="white" size={"3rem"} /></a>
        </div>
      </div>
    </div>
  );
};

export default Footer;